export const selectSystemConversions = (state) => state.systemConversions;
const selectSystemConversionLogs = (state) => state.systemConversionLogs;
export const selectSystemConversionLogsData = (state) => selectSystemConversionLogs(state).data;
export const selectSystemConversionLogsTotal = (state) => selectSystemConversionLogs(state).total;
export const selectCurrentConversionId = (state) => state.currentConversionId;
export const selectSystemConversionsResource = (state) => state.systemConversionsResource;
